module.exports = __webpack_public_path__ + "img/efba8c0.png";